// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"Charts_TheComp__xaTT_"};